import React from "react";
import { Dashboard } from "./Pages/Dashboard";
import { Lending } from "./Pages/Lending";
import { Login } from "./Pages/Login";
import { SignUp } from "./Pages/SignUp";
import { Routes, Route, Navigate } from "react-router-dom";
import { fetchLogin, isAuthSelector } from "./redux/slices/auth";
import { useSelector, useDispatch } from "react-redux";
import { Context } from "./Context";
import { Success } from "./Pages/Success";
import { Cancel } from "./Pages/Cancel";
import { PageNotFound } from "./Pages/PageNotFound";
import { SuccessPayPal } from "./Pages/SuccessPayPal";
import { Payment } from "./Pages/Payment";
import { NoAccSuccess } from "./Pages/NoAccSuccess";
import { NoAccSuccessPaypal } from "./Pages/NoAccSuccessPaypal";
import { Policy } from "./Pages/Policy";
import { Terms } from "./Pages/Terms";
import { PopUpCookies } from "./components/PopUpCookies";
import { PaymentPrompts } from "./Pages/PaymentPrompts";
import { ForgotPass } from "./Pages/ForgotPass";
import { ResetPasswordForm } from "./Pages/ResetPasswordForm";
import { ActivateAccount } from "./Pages/ActivateAccount";

function App() {
  const [userData, setUserData] = React.useState({});
  const [viewBar, setViewBar] = React.useState(true);
  const [linkImg, setLinkImg] = React.useState("");
  const [links, setLinks] = React.useState([]);
  const [paymentSum, setPaymentSum] = React.useState(0);
  const [addCollection, setAddCollection] = React.useState(false);
  const [checkAddImg, setCheckAddImg] = React.useState(false);
  const [activationCheck, setActivationCheck] = React.useState(false);
  const [checkLoadingActivation, setCheckLoadingActivation] =
    React.useState(true);
  const dispatch = useDispatch();
  const fetchDataUser = async () => {
    const data = await dispatch(fetchLogin());

    if (data.payload) {
      const { email, prompts, links, paymentHistory, activation } =
        data.payload;
      setUserData({ email, prompts, paymentHistory, activation });
      setActivationCheck(activation);
      setLinks([...links]);
      setCheckLoadingActivation(false);
    }
  };

  React.useEffect(() => {
    fetchDataUser();
    setCheckLoadingActivation(false);
  }, []);
  return (
    <Context.Provider
      value={{
        userData,
        setUserData,
        viewBar,
        setViewBar,
        linkImg,
        setLinkImg,
        links,
        setLinks,
        addCollection,
        setAddCollection,
        checkAddImg,
        setCheckAddImg,
        paymentSum,
        setPaymentSum,
        activationCheck,
        setActivationCheck,
        checkLoadingActivation,
      }}
    >
      <div className="container mx-auto">
        <Routes>
          <Route path="/" element={<Lending />} />
          <Route path="Login" element={<Login />} />
          <Route path="SignUp" element={<SignUp />} />
          <Route path="Payment" element={<Payment />} />
          <Route path="Dashboard/*" element={<Dashboard />} />
          <Route path="Success" element={<Success />} />
          <Route path="newprofile/success" element={<NoAccSuccess />} />
          <Route
            path="newprofile/paypal/success"
            element={<NoAccSuccessPaypal />}
          />
          <Route path="paypal/success" element={<SuccessPayPal />} />
          <Route path="Cancel" element={<Cancel />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="Policy" element={<Policy />} />
          <Route path="Terms" element={<Terms />} />
          <Route path="PaymentPrompts" element={<PaymentPrompts />} />
          <Route path="ForgotPassword" element={<ForgotPass />} />
          <Route path="reset-password" element={<ResetPasswordForm />} />
          <Route path="ActivateAccount" element={<ActivateAccount />} />
        </Routes>
        {/* <PopUpCookies /> */}
      </div>
    </Context.Provider>
  );
}

export default App;
